import React, { Fragment } from 'react';
import styles from './HowItWorks.scss';
import Section from './Section';
import {Col, Row} from 'reactstrap';
import AddIcon from '../../assets/images/icons/step1_add.svg';
import SyndicateIcon from '../../assets/images/icons/step2_syndicate.svg';
import ReportIcon from '../../assets/images/icons/step3_reports.svg';

const HowItWorks = () => (
  <Section title="How it works" id="how-it-works-section" subtitle={
    <Fragment>Submit your event once and promote it everywhere <br/>
    based on the event category and location.</Fragment>}>
    <Row className={styles.howItWorks}>
      <Col lg="4">
        <div className="big-circle">
          <img src={AddIcon}/>
        </div>
        <h3 className="step-title">
          You add your events
          <span className="step-number">
            1
          </span>
        </h3>
        <div className="description">
          Simply create a new event using our submission forms or import your events from Eventbrite, Yext, any of our partners etc...
        </div>
      </Col>
      <Col lg="4" className="mt-5">
        <div className="big-circle">
          <img src={SyndicateIcon}/>
        </div>
        <h3 className="step-title">
          Sit back while we do all the <br/>
          hard work for you
          <span className="step-number">
            2
          </span>
        </h3>
        <div className="description">
          We put your event where consumers are looking, syndicating your events content across the web, including premium featured placement and beyond.
        </div>
      </Col>
      <Col lg="4">
        <div className="big-circle">
          <img src={ReportIcon}/>
        </div>
        <h3 className="step-title">
          Monitor and track results
          <span className="step-number">
                    3
          </span>
        </h3>
        <div className="description">
          Track and analyze your events from the first submission through to the day of your event.
        </div>
      </Col>
    </Row>
  </Section>
);

export default HowItWorks;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/snapsell/HowItWorks.jsx